import {StockValue} from 'features/stock/types/stock-value';
import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const getProductsInStock = api.injectEndpoints({
  endpoints: builder => ({
    getProductsInStock: builder.query<Response, Request>({
      query: params => ({
        method: 'GET',
        url: `stock/product-collections/${params.collectionId}/families/${params.id}/products`,
        params: {
          type: params.type,
        },
      }),
      forceRefetch: () => true,
    }),
  }),
});

type Request = {
  id?: ObjectId;
  collectionId: ObjectId;
  type: string;
};
type Response = ResponseData<
  {
    id: ObjectId;
    name: string;
    stock: StockValue[];
  }[]
>;

export const {useGetProductsInStockQuery} = getProductsInStock;
